module.exports = __webpack_public_path__ + "img/PG.63e9f412.png";